import {Component, Inject, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {BehaviorSubject, Subscription} from "rxjs";
import {NgForm} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Message} from "../../../../../../core/class/message";
import {ToastrService} from "ngx-toastr";
import {DocumentService} from "../../../../../../core/services/document.service";
import {NotificationService} from "../../../../../../core/services/notification.service";
import {WarningComponent} from "../../../../../../shared/components/warning/warning.component";
import { Location } from '@angular/common';
import { DeclineApproveDocumentListComponent } from '../sign-document/decline-approve-document-list/decline-approve-document-list.component';

@Component({
  selector: 'app-declined-approve-document',
  templateUrl: './decline-approve-document.component.html',
  styleUrls: ['./decline-approve-document.component.scss']
})
export class DeclineApproveDocumentComponent implements OnInit {
  document = {
    id: 0,
    reason: ''
  };
    formChangesSubscription: Subscription;
  @ViewChild('f', {static: false}) ngForm: NgForm;
  public isFormChanging: boolean;
  private success: boolean;
  constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private message: Message,
    private toastr: ToastrService,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<DeclineApproveDocumentComponent>,
    public notificationService: NotificationService,
    private location: Location,
  ) {
        this.document = data.document;
  }

  public actions = new BehaviorSubject<any>('');

    ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });

    // Focus on textarea reason after load
    // There's a problem if not setTimeout it will focus on 'reason' then lost focus right after
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }

  ngOnInit() {
    this.notificationService.subscribeErrorService();

  }

  cancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  declineApproveDocument() {
    if (this.location.path() === '/home-enterprise/search-approval-waiting-document') {
      this.actions.next({type:DeclineApproveDocumentListComponent.DECLINE_ACTION, document: this.document});
    } else {
    this.documentService.declineApproveDocument(this.document).subscribe(rs => {
      this.success = true;
      this.toastr.success(this.message.getMessage('messages.refuse_approve_success'));
      this.dialogRef.close(true);
    });
  }
}

}
